import React from 'react';
import { PRODUCT_NAME } from './constants';
export function Footer() {
  return <footer className="bg-brand-ink px-4 py-5 text-center text-white/55 text-[11px]" data-id="element-68" data-mp="3gezcx2w41p0m">
      <div className="max-w-3xl mx-auto space-y-2" data-id="element-69" data-mp="32nukakr5twzs">
        <p className="font-heading font-bold text-white/80 text-xs" data-id="element-70" data-mp="32p5m4f11ouo9">
          © 2026 {PRODUCT_NAME} — All Rights Reserved.
        </p>
        <p className="leading-snug max-w-2xl mx-auto font-medium" data-id="element-71" data-mp="36n3dnoiafsut">
          {PRODUCT_NAME} provides educational, teaching and lesson-planning
          resources for Physical Education professionals. It does not replace
          professional qualifications, institutional policies, curriculum
          requirements, medical advice or professional judgment.
        </p>
        <div className="flex justify-center gap-2 font-heading font-bold uppercase tracking-wide text-white/65" data-id="element-72" data-mp="3qbvoxil7wt9x">
          <a href="#" className="hover:text-brand-orange transition-colors duration-150 ease-out" data-id="element-73" data-mp="29xvswiphtnry">
            Terms &amp; Conditions
          </a>
          <span aria-hidden="true" data-id="element-74" data-mp="3la29euiur3v8">•</span>
          <a href="#" className="hover:text-brand-orange transition-colors duration-150 ease-out" data-id="element-75" data-mp="3gah1hulpfl6d">
            Privacy Policy
          </a>
          <span aria-hidden="true" data-id="element-76" data-mp="3v5n4s9tf15w0">•</span>
          <a href="#" className="hover:text-brand-orange transition-colors duration-150 ease-out" data-id="element-77" data-mp="3q83shfga336p">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}